var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatedStud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 16,
    fill: "#FCB546",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4342 14.8298V12C32.1597 12.6308 35.7679 14.9319 38.1616 19.0544C39.8222 21.9153 40.3301 25.0249 39.8001 28.29C39.2702 31.5463 37.7244 34.2561 35.2733 36.5217H38.5768V39.3248H30.2386V30.9465H32.9989V34.7536C34.4254 33.5853 35.4632 32.2437 36.1919 30.6489C36.925 29.0452 37.2519 27.3616 37.1944 25.598C37.0045 19.9118 32.5705 15.3939 27.4386 14.8298H27.4342Z",
    fill: "#FCB546"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6209 40C19.595 39.2937 15.7307 36.8371 13.5666 32.257C10.6032 25.9889 11.9547 20.3782 16.6846 15.4694H13.4783V12.6708H21.8165V21.049H19.0518V17.2464C17.6209 18.4058 16.5875 19.7519 15.8588 21.3467C15.1301 22.9414 14.7988 24.6162 14.8607 26.3665C14.9622 29.1118 15.9294 31.5196 17.7711 33.5497C19.6127 35.5799 21.9092 36.7527 24.6165 37.1436V40H24.6209Z",
    fill: "#FCB546"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8991 20.5338C32.588 21.2268 33.2284 21.8665 33.8423 22.4839C30.5697 25.7713 27.2884 29.0719 24.0202 32.3592C22.1035 30.4268 20.1426 28.4589 18.2082 26.5131C18.8354 25.8912 19.4801 25.2515 20.147 24.5852C21.3925 25.8512 22.6909 27.175 23.9937 28.4989C26.6612 25.8112 29.2802 23.1725 31.8991 20.5338Z",
    fill: "#FCB546"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedStud);
export default __webpack_public_path__ + "static/media/updated_stud.67b3a0da063affe450edcbffb6955e7a.svg";
export { ForwardRef as ReactComponent };